(() => {
  const filterURL = (form, current) => {
    const url = new URL(current);
    const names = new Set([...form.elements].map(input => input.name).filter(Boolean));
    names.forEach(name => url.searchParams.delete(name));
    for (const [key, value] of new FormData(form)) if (String(value).trim()) url.searchParams.append(key, value);
    url.searchParams.delete('page');
    return url;
  };
  window.DianaPeacockCommerce = { filterURL };
  function initialize(scope = document) {
    scope.querySelectorAll('[data-pc-product]').forEach(root => {
      if (root.dataset.pcReady) return;
      root.dataset.pcReady = 'true';
      const form = root.querySelector('[data-pc-product-form]');
      if (!form) return;
      const id = form.querySelector('[name="id"]');
      const quantity = form.querySelector('[name="quantity"]');
      const button = form.querySelector('[data-pc-add]');
      const status = form.querySelector('[data-pc-status]');
      const bag = form.querySelector('[data-pc-bag-link]');
      const quickCheckout = form.querySelector('[data-pc-quick-checkout]');
      let busy = false;
      const available = () => root.querySelector('[data-pc-variant][aria-current="true"]')?.dataset.available === 'true';
      const syncQuickCheckout = () => {
        if (!quickCheckout) return;
        quickCheckout.hidden = !available() || !quantity.checkValidity();
        quickCheckout.inert = busy;
        quickCheckout.setAttribute('aria-busy', String(busy));
      };
      quantity.addEventListener('input', syncQuickCheckout);
      quantity.addEventListener('change', syncQuickCheckout);
      syncQuickCheckout();
      root.querySelectorAll('[data-pc-variant]').forEach(choice => choice.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (busy) return;
        id.value = choice.dataset.pcVariant;
        root.querySelector('[data-pc-price]').textContent = choice.dataset.price;
        const fit = root.querySelector('[data-pc-fit]');
        const fitTemplate = [...root.querySelectorAll('template[data-pc-fit-for]')].find(template => template.dataset.pcFitFor === id.value);
        if (fit && fitTemplate) fit.replaceChildren(fitTemplate.content.cloneNode(true));
        root.querySelectorAll('[data-pc-variant]').forEach(other => other.removeAttribute('aria-current'));
        choice.setAttribute('aria-current', 'true');
        id.dispatchEvent(new Event('input', { bubbles: true }));
        id.dispatchEvent(new Event('change', { bubbles: true }));
        syncQuickCheckout();
        button.disabled = !available();
        button.textContent = available() ? 'Add to bag' : 'Sold out';
        status.textContent = '';
        bag.hidden = true;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', id.value);
        window.history.replaceState({}, '', url);
      }));
      root.querySelectorAll('[data-pc-quantity]').forEach(control => control.addEventListener('click', () => {
        quantity.value = String(Math.max(1, (parseInt(quantity.value, 10) || 1) + Number(control.dataset.pcQuantity)));
        quantity.dispatchEvent(new Event('input', { bubbles: true }));
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      root.querySelectorAll('[data-pc-open-fit]').forEach(link => link.addEventListener('click', () => {
        const target = document.getElementById(link.hash.slice(1));
        if (target) target.open = true;
      }));
      form.addEventListener('submit', async event => {
        // Shopify owns accelerated checkout; only intercept our add-to-bag action.
        if (event.submitter && event.submitter !== button) return;
        if (!window.fetch) return;
        event.preventDefault();
        if (busy || !available() || !form.reportValidity()) return;
        busy = true;
        syncQuickCheckout();
        button.disabled = true;
        button.textContent = 'Adding…';
        status.textContent = '';
        bag.hidden = true;
        try {
          const endpoint = `${(form.dataset.addUrl || form.action.replace(window.location.origin, '')).replace(/\.js$/, '')}.js`;
          const response = await fetch(endpoint, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
          const result = await response.json();
          if (!response.ok || result.status || !result.id) throw new Error(result.description || 'We could not add this collar. Please try again.');
          status.textContent = 'Added to your bag.';
          bag.hidden = false;
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { item: result } }));
        } catch (error) {
          status.textContent = error.message === 'Failed to fetch' || error.message === 'Offline' ? 'We could not reach the shop. Please try again.' : (error.message || 'We could not add this collar. Please try again.');
        } finally {
          busy = false;
          syncQuickCheckout();
          button.disabled = !available();
          button.textContent = available() ? 'Add to bag' : 'Sold out';
        }
      });
    });
    scope.querySelectorAll('[data-pc-filter-form]').forEach(form => {
      if (form.dataset.pcReady) return;
      form.dataset.pcReady = 'true';
      form.addEventListener('submit', event => { event.preventDefault(); if (form.reportValidity()) window.location.assign(filterURL(form, window.location.href)); });
      form.querySelector('[data-pc-sort]')?.addEventListener('change', () => form.requestSubmit());
    });
    scope.querySelectorAll('.pc-commerce video').forEach(video => {
      if (video.dataset.pcReady) return;
      video.dataset.pcReady = 'true';
      video.addEventListener('play', () => document.querySelectorAll('.pc-commerce video').forEach(other => { if (other !== video) other.pause(); }));
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('visibilitychange', () => { if (document.hidden) document.querySelectorAll('.pc-commerce video').forEach(video => video.pause()); });
})();
